export default "__VITE_ASSET__Cr3rDXF5__"